import {
  Dispatch,
  PropsWithoutRef,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
} from "react";
import { Popover, PopoverTrigger, PopoverContent } from "@altimateai/lego";

const PopoverContext = createContext<{
  openedPopover: string;
  setOpenedPopover: Dispatch<SetStateAction<string>>;
}>({ openedPopover: "", setOpenedPopover: () => {} });

function BetterPopover({
  id,
  trigger,
  render,
}: PropsWithoutRef<{
  id: string;
  trigger: ReactNode;
  render: (_args: { close: () => void }) => ReactNode;
}>) {
  const { openedPopover, setOpenedPopover } = useContext(PopoverContext);

  return (
    <Popover open={openedPopover === id} onOpenChange={open => setOpenedPopover(open ? id : "")}>
      <PopoverTrigger asChild>
        <div
          id={id}
          onClick={e => {
            e.stopPropagation();
          }}
        >
          {trigger}
        </div>
      </PopoverTrigger>
      <PopoverContent className="al-tw-scope">
        <div>{render({ close: () => setOpenedPopover("") })}</div>
      </PopoverContent>
    </Popover>
  );
}

export { BetterPopover, PopoverContext };
